import {GrowthBook} from "@growthbook/growthbook";
import ChangeHeaderCTA from "./experiments/ChangeHeaderCTA";

document.addEventListener('DOMContentLoaded', function () {
	if (!growthbook_args && !growthbook_args.settings.growthbook_client_key) {
		return;
	}
	const userId = getUserId();

	const growthbook = new GrowthBook({
		apiHost: "https://cdn.growthbook.io",
		clientKey: growthbook_args.settings.growthbook_client_key,
		enableDevMode: true,
		subscribeToChanges: true,
		attributes: {
			id: userId,
		},
		trackingCallback: (experiment, result) => {
			// TODO: Use your real analytics tracking system
			console.log("Viewed Experiment", {
				experimentId: experiment.key,
				variationId: result.key
			});
		}
	});

	// Wait for features to be available
	growthbook.loadFeatures().then(function () {
		const createProjectAppVersion = new ChangeHeaderCTA(growthbook);
	});
});

function getUserId() {
	let userId = localStorage.getItem('userId');
	if (!userId) {
		userId = 'user-' + Math.floor(Math.random() * Date.now() * 100).toString(16);
		localStorage.setItem('userId', userId);
	}
	return userId;
}